import { render, staticRenderFns } from "./exam-manage.vue?vue&type=template&id=2afc10a1&scoped=true&"
import script from "./exam-manage.vue?vue&type=script&lang=js&"
export * from "./exam-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc10a1",
  null
  
)

export default component.exports